export default {
	"item.MallOrderConfirmationPageCouponRetentionPopUpWindowConfirmationButton": "商城訂單確認頁_優惠券挽留彈窗_確認按鈕",
	"item.AcceptAndUse": "收下並使用",
	"item.PickUpFailed": "領取失敗",
	"item.NoProductsSelected": "未選擇商品",
	"item.NoAddressSelected": "未選擇位址",
	"item.IfYouAreBuyingInInstallmentsPleaseSelectTheNumberOfInstallments": "如若分期購買請選擇期數",
	"item.MarketplaceOrderConfirmationPagebottomButton": "商城訂單確認頁_底部按鈕",
	"item.prompt": "提示",
	"item.UntieTheBindingForTheTimeBeing": "暫不解綁",
	"item.UnbindTheAccount": "解綁帳號",
	"item.AccordingToTheRequirementsOfNationalPoliciesTheExpressMailSentToTaiwanNeedsToFillInTheCertificateNumberPleaseFillIn": "根據國家政策要求，發往臺灣地區的快件需填寫證件號碼，請您補充填寫",
	"item.Cancel": "取消",
	"item.GoReplenishment": "去補充",
	"item.SorryThePriceHasChanged": "抱歉，價格已發生變化！",
	"item.SorryFailedToCreateOrder": "抱歉，創建訂單失敗！",
	"item.RepeatPurchasePrompts": "重複購買提示",
	"item.ignore": "忽略",
	"item.ViewOrders": "查看訂單",
	"item.WeChatCanEnterTheAccessAfterAuthorizationRequestAuthorization": "微信授權後可進入訪問，請求授權中···",
	"item.OnTheMarketplaceOrderConfirmationPageClickOnAddress": "商城訂單確認頁_位址點擊",
	"item.MarketplaceOrderConfirmationPagecouponClick": "商城訂單確認頁_優惠券點擊",
	"item.Removed": "已下架",
	"item.SoldOut": "已售罄",
	"item.InsufficientGrowthBeans": "成長豆不足",
	"item.RedeemNow": "立即兌換",
	"item.SubmitYourOrder": "提交訂單",
	"item.ParameterError": "參數錯誤！",
	"item.FirstInstalmentCredit": "首期優惠抵扣",
	"item.PleaseSelectAnAvailableCoupon": "請選擇可用優惠券",
	"item.NoOffersAvailable": "無可用優惠",
	"item.ContinuousPackages": "連續包",
	"item.Every": "：每",
	"item.ChargesAreDeducted": "扣費",
	"item.head": "，首",
	"item.ImmediatelyReduced": "立減",
	"item.ThereIsNoDeliveryAddress": "暫無收貨位址",
	"item.PleaseAddAShippingAddress": "請添加收貨位址",
	"item.CallItOfficial": "叫叫官方",
	"item.Selected": "已選：",
	"item.DeliveryMethod": "交付方法",
	"item.ExpressDelivery": "快遞配送",
	"item.Coupons": "優惠券",
	"item.use": "使用",
	"item.Deductions": "抵扣",
	"item.GrowBeans": "成長豆",
	"item.RemainingGrowingBeans": "剩餘成長豆：",
	"item.TotalPayableForTheCurrentPeriod": "本期應付總額",
	"item.TheAmountOfTheItem": "商品金額",
	"item.freight": "運費",
	"item.total": "合計",
	"item.FlowerStaging": "花唄分期",
	"item.divide": "分",
	"item.timeLimit": "期",
	"item.Total¥": "總額¥",
	"item.HandlingFee¥": "手續費¥",
	"item.PleaseSelectTheStagingType": "請選擇分期類型",
	"item.Total": "合計：",
	"item.InstallmentTotal": "分期總額：",
	"item.Premium": "手續費：",
	"item.PerIssue": "/每期",
	"item.GotIt": "知道了",
	"item.ToPayForThisOrderPleasePayInTheOrderLogisticsOfTheCallPublicAccount": "支付該訂單請在《叫叫》公眾號的訂單物流中進行支付",
	"item.GrowingBeansUsageRules": "成長豆使用規則",
	"item.ProductDetailPageRetentionPopUpExposure": "商品詳情頁_挽留 彈窗曝光",
	"item.shoppingCentre": "商城",
	"item.ProductDetailPageRetainPopUpContentButtonClick": "商品詳情頁_挽留彈窗內容按鈕點擊",
	"item.other": "其他",
	"item.ClickTheBottomButtonOnTheProductDetailPageRetentionPopUpWindow": "商品詳情頁_挽留彈窗底部按鈕點擊",
	"item.abandon": "放棄"
}